/*
 * @Description: 南通拇指英文
 * @Author: zml
 * @Date: 2023-03-23 14:52:59
 * @LastEditors: zml
 * @LastEditTime: 2023-12-25 17:06:10
 */
export default {
    "NT.login":"Login",
    "NT.register":"Register",
    "NT.logout":"Logout",
    "NT.MyOrder":"My Order",
    "NT.logoBox.placeholder": "Keyword",
    "NT.logoBox.search": "Search",
    "NT.logoBox.AdvancedSearch": "Advanced Search",
    "NT.nav.Products": "PRODUCTS",
    "NT.nav.news": "NEWS",
    "NT.ViewPrice": "View Price",
    "NT.SameFactory": "Same Factory",
    "NT.newPro": "NEW ARRIVIALS",
    "NT.AnotherBatch": "Another Batch",
    "NT.ViewMore": "View More",
    "NT.hotPro": "HOT ITEMS",
    "NT.hotVidio": "HOT ITEM VODEO",
    "NT.proUnBoxVidio": "PRODUCT UNBOXING VIDEO",
    "NT.Search": "SEARCH",
    "NT.Reset": "RESET",
    "NT.ItemNO": "Item NO.",
    "NT.MTCode": "MT Code",
    "NT.FTYCode": "FTY Code",
    "NT.Kind": "Kind",
    "NT.Size": "Size",
    "NT.Price": "Price",
    "NT.Date": "Date",
    "NT.Sort": "Sort",
    "NT.DateDesc": "DATE DESC",
    "NT.DateAsc": "DATE ASC",
    "NT.PriceDesc": "PRICE DESC",
    "NT.PriceAsc": "PRICE ASC",
    "NT.NO.Desc": "NO. DESC",
    "NT.NO.Asc": "NO. ASC",
    "NT.PleaseEnterTheProductNameKeyword": "Please enter the product name keyword",
    "NT.PleaseSelect": "Please select",
    "NT.PleaseLength": "Length",
    "NT.PleaseWidth": "Width",
    "NT.PleaseHeight": "Height",
    "NT.PleaseMinPrice": "Min price",
    "NT.PleaseMaxPrice": "Max price",
    "NT.PleaseStartDate": "Start date",
    "NT.PleaseEndDate": "End date",
    "NT.UserAccount": "User Account",
    "NT.password": "Password",
    "NT.GROUPSEARCH": "GROUPSEARCH",
    "NT.Video_playback": "Video playing",
    "NT.loginMsg": "Access your account and order history",
    "NT.onUserAccount": "No account",
    "NT.SignUp": "Sign up",
    "NT.ForgetPassword": "Forget password",
    "NT.resetPasswords": "Reset password",
    "NT.emailAddress": "Email address",
    "NT.verifyCode": "Verify code",
    "NT.getVerifyCode": "Get code",
    "NT.newPassword": "New password",
    "NT.confirmPassword": "Confirm password",
    "NT.Submit": "Submit",
    "NT.SignUpAccount": "Sign up",
    "NT.LoginOnly": "Login only",
    "NT.Name": "Name",
    "NT.NameMsg": "Please enter your name, 2 to 30 characters",
    "NT.passwordMsg": "At least 6 characters",
    "NT.requiredFields": "*Required fields",
    "NT.Email": "Email",
    "NT.EmailMsg": "Please enter email. Used for login",
    "NT.gender": "Gender",
    "NT.man": "Mr.",
    "NT.woman": "Ms.",
    "NT.customerSource": "Customer source",
    "NT.salesman": "Contact Salesman",
    "NT.Country": "Country",
    "NT.Company": "Company",
    "NT.duty": "Job Titel",
    "NT.tel": "Tel",
    "NT.mobile": "Mobile",
    "NT.fax": "Fax",
    "NT.Yahoo": "Yahoo",
    "NT.website": "Website",
    "NT.address": "Address",
    "NT.postalCode": "Postal code",
    "NT.ExistingAccount": "Existing account",
    "NT.DirectLogin": "Direct login",
    "NT.productPrice": "Price",
    "NT.ProductNumber": "Item NO.",
    "NT.Packing": "Packing",
    "NT.OuterBoxCBM": "CBM",
    "NT.OuterBoxCUFT": "CUFT",
    "NT.Innerboxes": "Inner Boxes",
    "NT.OuterQTY": "Outer QTY",
    "NT.GWAndNW": "G.W/N.W",
    "NT.productSize": "Product Size",
    "NT.packageSize": "Package Size",
    "NT.cartonSize": "Carton Size",
    "NT.addCart": "Add To Cart",
    "NT.delCart": "Remove from Cart",
    "NT.product": "PRODUCTS",
    "NT.NewsUpdates": "News Updates",
    "NT.ReleaseDate":"Release Date",
    "NT.MyCart":"My Cart",
    "NT.ID":"ID",
    "NT.picture":"Picture",
    "NT.ArticleNo":"Item No.",
    "NT.Description":"Product Name",
    "NT.CartOuterQTY":"Outer QTY",
    "NT.CBM":"CBM",
    "NT.CTNS":"CTNS",
    "NT.totalQTY": "Total QTY",
    "NT.TotalVolume":"Total CBM",
    "NT.total":"Total",
    "NT.delete":"Delete",
    "NT.checkAll":"Check All",
    "NT.clear":"Clear",
    "NT.totalItems": "Total Items",
    "NT.totalCTNS": "Total CTNS",
    "NT.noData": "No Data",
    "NT.totalPrice": "Total Price",
    "NT.systemTip": "Tip",
    "NT.confirm": "Confirm",
    "NT.cancel": "Cancel",
    "NT.deleteData": "Do you want to delete the data?",
    "NT.clearCartData": "Do you want to empty your shopping cart?",
    "NT.submitTip": "Confirm to submit the order?",
    "NT.MyOrder": "My Order",
    "NT.PleaseOrderNum": "Please enter the order number",
    "NT.number": "Number",
    "NT.viewDetails": "View Details",
    "NT.orderTime": "Creation time",
    "NT.linkman": "Linkman",
    "NT.sendDate": "Delivery Date",
    "NT.expressNumber": "Tracking Number",
    "NT.orderStatus": "Order Status",
    "NT.unshipped": "Unshipped",
    "NT.shipped": "Shipped",
    "NT.SiteNavigation": "Site Navigation",
    "NT.ContactUs": "Contact us",
    "NT.FollowUs": "Follow us",
    "NT.Landline": "Landline",
    "NT.Email": "E-mail",
    "NT.Phone": "Phone",
    "NT.WeChat": "WeChat",
    "NT.Technic": "Technic Sustain",
    "NT.Software": "HongSheng Soft",
    "NT.detailBtn": "Product details",
    "NT.noDetailBtn": "No product details",
    "NT.classify": "CATALOG",
    "NT.exclusive": "EXCLUSIVE RECOMMENDATIONS",
    "NT.loading": "Loading...",
    "NT.updateTime": "UpdateTime",
    "NT.SearchMsg": "The above search criteria can be any one or more comprehensive searches",
    "NT.MessageTitle": "Submit your requirements online",
    "NT.MessageMsg": "We will reply to your email within 24 hours, except for holidays. We look forward to hearing your voice, helping you solve problems, answering doubts, and exploring cooperation opportunities together. Thank you for choosing us, we will be dedicated to serving you!",
    "NT.MessageName": "YOUR NAME",
    "NT.MessageTel": "YOUR PHONE",
    "NT.MessageEmail": "YOUR EMAIL",
    "NT.MessageNeeds": "YOUR NEEDS",
    "NT.SendInquiry": "Send Inquiry",
    "NT.EnquiryList": "ENQUIRY",
    "NT.enquiry": "Enquiry",
    "NT.MyEnquiryList": "My Inquiry Form",
    "NT.Remark": "Remark",
    "NT.Enquirys": "Leave your email and we'll get back to you",
    "NT.proClass": "Product Category",
    "NT.submitOrder": "Confirm submitting the inquiry?",

    "NT.Co-branding": "Co-branding",
    "NT.Co-brandingMsg": "More than 100 companies have conducted in-depth cooperation with our company",
    "NT.recommendPro": "Recommended products",
    "NT.Blog": "Blog",
    "NT.More": "More",
    "NT.nav.Home": "Home",
    "NT.nav.category": "Category",
    "NT.nav.Hot": "Hot Selling",
    "NT.nav.Gift": "Gift",
    "NT.nav.New": "New Product",
    "NT.nav.video": "Video",
    "NT.nav.Blog": "Blog",
    "NT.nav.About": "About Us",
    "NT.nav.contact": "Contact Us",
    "NT.nav.FooterNew": "New Product",
    "NT.news.title": "All Blogs",
    "NT.noMore": "There's no more",
    "NT.top.cart": "Cart",
    "NT.fomcat.title": "Why choose the Fomcat brand",
    "NT.fomcat.titleMsg": "The advantages are all here! The advantages of Fomcat toy wholesalers cannot be ignored, let's see why we are your best partner!",
    "NT.fomcat1.title1": "Diversified product range",
    "NT.fomcat1.Msg1": "Covering children's toys, remote control toys, models and collectibles, meeting different customer needs. No matter which age group your store is targeting, we have the perfect choice!",
    "NT.fomcat2.title1": "Material quality assurance",
    "NT.fomcat2.Msg1": "We select high-quality materials to create safe and reliable toys for children, undergo market testing, and let parents and children enjoy themselves with peace of mind!",
    "NT.fomcat3.title1": "Competitive wholesale prices",
    "NT.fomcat3.Msg1": "We offer highly competitive wholesale prices, bringing you greater profit margins!",
    "NT.fomcat4.title1": "Easy collaboration",
    "NT.fomcat4.Msg1": "Feel free to contact us and our team will efficiently solve your problems and needs. Our goal is to establish a long-term and successful partnership!",
    "NT.fomcat5.title1": "Convenient ordering",
    "NT.fomcat5.title2": "Intimate service",
    "NT.fomcat5.Mag1": "Your success is our success! Choose the Fomcat brand and work with us to create a beautiful toy paradise!",
    "NT.userGuide": "User's Guide",
    "NT.internationalTransport": "International Transport",
    "NT.cardTitle1": "About QianMeng Technology",
    "NT.cardTitle2": "Logistics and transportation services of QianMeng Technology",
    "NT.cardMsg": "Can represent you in managing the entire logistics process of importing goods from China; It can also completely change the way you purchase and import from China, saving you business time and procurement costs.",
    "NT.card1Title": "Our strengths",
    "NT.card2.Title1": "Logistics Process",
    "NT.card2.Title01": "Factory shipment",
    "NT.card2.Title02": "China's shipment volume",
    "NT.card2.Title03": "Chinese warehouse",
    "NT.card2.Title04": "China Customs",
    "NT.card2.Title05": "International Delivery",
    "NT.card2.Title06": "Global Customs",
    "NT.card2.Title07": "Global domestic transportation",
    "NT.card3.Title": "Logistics services include",
    "NT.card3.msg1": "Provide complete logistics services from the supplier's factory to your shipping address. This allows our customers to monitor the location of their goods during the import process at any time.",
    "NT.card3.msg2": "We have over 70000 square meters of warehouses in China, where we receive, process, and store goods until they are shipped globally.",
    "NT.card3.li": "Receiving goods from the factory",
    "NT.card3.li2": "Storage",
    "NT.card3.li3": "Goods packaging",
    "NT.card3.li4": "Quality control",
    "NT.card3.li5": "Product Production Certificate",
    "NT.card3.li6": "Declare sth. at the customs",
    "NT.card3.li7": "Other services",
    "NT.card4.title": "Information on international transportation and delivery",
    "NT.card4.cell.title": "Estimated cost",
    "NT.card4.cell.msg1": "In order to provide a transportation quotation, we need to know whether the items included in your order are subject to import and export restrictions, whether the factory has inventory, dimensions, and the exact weight of the product.",
    "NT.card4.cell.msg2": "That's why our team needs to contact suppliers to understand this type of information and provide cost estimates.",
    "NT.card4.cell.msg3": "You will receive detailed estimates of transportation costs, cubic volumes, and delivery times for three available modes of transportation (sea freight, air freight, and FedEx).",
    "NT.card4.cell2.title": "Final quotation and transportation",
    "NT.card4.cell2.msg1": "The best transportation quotation can only be obtained after the goods arrive at our warehouse. Therefore, accurate freight quotes and other expenses are calculated after we receive the goods.",
    "NT.card4.cell2.msg2": "Once the items arrive at our warehouse, we will group them into groups to provide the most favorable prices.",
    "NT.card4.cell3.title": "Freight details",
    "NT.card4.cell3.msg1": "International freight.",
    "NT.card4.cell3.msg2": "International shipping costs to the world.",
    "NT.card4.cell3.msg3": "Global domestic logistics costs.",
    "NT.card4.cell3.msg4": "After global customs clearance, we will arrange domestic shipments based on the delivery address.",
    "NT.card4.cell4.title": "Transportation of dangerous goods",
    "NT.card4.cell4.msg1": "Dangerous goods are items with the following characteristics and attributes: threatening human life and health; Causing irreparable damage to the environment; Causing damage to physical objects.",
    "NT.card4.cell4.msg2": "These goods include: animals and animal products, plant products, animal and vegetable fats, food agents, ordinary metals, precision instruments, weapons, ammunition, and artworks.",

    "NT.card4.cell5.title": "Choose an international shipping company",
    "NT.card4.cell5.msg1": "We will choose reliable, fast, and economical international logistics channels for your goods. After careful evaluation, we have comprehensively considered factors such as transportation cost, transportation efficiency, and service stability.",
    "NT.card4.cell5.msg2": "We will continuously strive to find the best logistics partners and transportation routes to serve you on our platform.",

    "NT.card4.cell6.title": "Declare sth. at the customs",
    "NT.card4.cell6.msg1": "The customs clearance will be determined based on the customs clearance method (sea, air, or land) you choose when requesting delivery.",
    "NT.card4.cell6.msg2": "Our company is responsible for handling relevant customs clearance matters. Our company will be responsible for relevant customs clearance matters. Customers can also choose to handle customs clearance procedures themselves.",
    "NT.contact.title": "Your satisfaction is our greatest pursuit. If you have any questions, suggestions or cooperation intentions, please feel free to contact us at any time. We are always ready to provide you with support and assistance.",
    "NT.cacontact.card1.title": "Contact information",
    "NT.cacontact.card1.msg": "Think more for you, do better for you",
    "NT.Official.website": "Official Website",
    "NT.link": "Click on the image to go to the official website",
    "NT.about.subject": "Fomtoy makes imports easier",
    "NT.about.msg": "Fomtoy is an integrated import platform that provides you with tens of thousands of suppliers, enabling you to import products at more competitive prices. We will also manage the entire procurement, logistics, and import process for you.",
    "NT.about.card1.title": "The most powerful B2B e-commerce solution in China",
    "NT.about.card1.content": "Fomtoy is a B2B company whose main goal is to help businesses import products from China in the most cost-effective way, save costs and simplify processes, and provide customers with the best import experience. Our headquarters is located in Suzhou, China, with over 4000 square meters of office operation area and 15000 square meters of warehouse. We have 300 employees and an independent technology research and development team in the group company.",
    "NT.about.card1.label": "Spot Products",
    "NT.about.card1.label2": "Patent",
    "NT.about.card1.label3": "New product",
    "NT.about.card1.label4": "Country",
    "NT.about.card2.title": "Our strengths",
    "NT.about.card2.msg": "We not only dare to promise, but also can do it",
    "NT.about.card2.cell.tit": "Simplify your procurement and imports from China, optimize all costs",
    "NT.about.card2.cell.msg": "The English interface allows you to easily complete the procurement process. Provide quality control, warehousing, international logistics, customs clearance, and additional services. English customer service facilitates communication and after-sales service",
    "NT.about.card2.cell2.tit": "Optimize transportation and import costs",
    "NT.about.card2.cell2.tit2": "The entire process of importing from a single site",
    "NT.about.card2.cell2.tit3": "Warehousing and comprehensive import management",
    "NT.about.card2.cell2.tit4": "Bilingual customer service and after-sales service",
    "NT.about.card2.cell3.tit": "Find everything you want, the world factory is in your hands",
    "NT.about.card2.cell3.msg": "At present, users can find any product from Alibaba, 1688, and other large domestic e-commerce platforms in China on Rakumart. Our extensive cooperation network enables us to provide you with a variety of products and over 100000 high-quality Chinese suppliers.",
    "NT.about.card3.title": "We have clients from various businesses around the world, listen to their evaluations of us",
    "NT.about.card3.msg": "Searching for our location around the world?",
    "NT.about.card3.cell.tit": "The Magic of Fomtoy: The Behind the Scenes of Seamless Order Processing",
    "NT.about.card3.cell.msg": "Before encountering FulfillPanda, I was constantly troubled by the daily order volume. Their seamless order processing system truly changed the game rules, allowing me to focus on my business without worrying about inventory issues.",
    "NT.about.card3.cell2.tit": "3000 orders per day: My Fast Expansion Journey",
    "NT.about.card3.cell2.msg": "My business journey is facing challenges, but over time, with the help of FulfillPanda, I am now processing over 3000 orders per day. This rapid expansion is not just about quantity growth; This proves the hard work of our team with the support of Fomtoy.",
    "NT.about.card3.cell3.tit": "Beyond expectations: FulfillPanda provides more than just services",
    "NT.about.card3.cell3.msg": "In our collaboration with FulfillPanda, I found that they provide more than just one service. They closely monitor my business and provide solutions that exceed the expectations of traditional service providers. This is a sincere and enthusiastic cooperative relationship that goes far beyond the business field",
    "NT.about.card3.cell4.tit": "Fulfillpanda is a lifesaver...",
    "NT.about.card3.cell4.msg": "Even if I have a freight forwarder, it's difficult for me to scale proportionally. Due to running 17 regular stores for different reasons, such as store backup and testing with different advertising accounts. We test 50 products every day to find winners. My team has to occasionally post procurement requests to other platforms. This is very time-consuming. Meanwhile, FulfillPanda will closely monitor your every step, keeping you informed of any information related to inventory issues and providing solutions at any time. Thanks to them, we have to make 3000 orders every day. Most orders are shipped on time. I will definitely recommend FulfillPanda!",
    "NT.about.card4.tit": "Mission",
    "NT.about.card4.msg": "Our mission is to provide high-quality products with outstanding value. We listen to our customers and manufacturers. We observe the world they live in and provide them with new trends in multiple categories of goods. We are passionate about the companies we represent and the trends and innovative products they develop and create. We have been searching for incredible ideas, and we are eager to push these extraordinary new products to every market.",
    "NT.about.card4.subtitle": "01. Our Value",
    "NT.about.card4.cell.tit": "Goal oriented",
    "NT.about.card4.cell.msg": "We are still focused on maintaining profitability growth and expanding our distribution areas for our manufacturers.",
    "NT.about.card4.cell.tit2": "Good faith",
    "NT.about.card4.cell.msg2": "We operate with integrity and high ethical standards, and in everything we strive for.",
    "NT.about.card4.cell.tit3": "Professional ethics",
    "NT.about.card4.cell.msg3": "Diligence and perseverance are fundamental to every aspect of our business. In this challenging era, we work very hard.",
    "NT.about.card4.cell.tit4": "Attention to detail",
    "NT.about.card4.cell.msg4": "We realize that small issues require more attention, and then bigger things will take care of ourselves.",
    "NT.about.card4.subtitle2": "02. visión",
    "NT.about.card4.subtitle2.msg": "Our goal is to become a leader in providing more distribution for manufacturers by listening to the opinions of manufacturers, retailers, and consumers. Profit and structure in a high organizational system will create success. We strive to motivate our customer base with products they don't know about, they never know they need or exist. However, once they develop a liking for our products, they cannot understand their existence without them.",
    "NT.about.card5.Company": "Company headquarters",
    "NT.about.card5.info": "Suzhou, China",
    "NT.about.card5.address": "Company address",
    "NT.about.card5.addressName": "18th Floor, Office Building 1818, Industrial Park, Suzhou City, Jiangsu Province",
    "NT.about.card5.Telephone": "Telephone",




}   
